var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTbbEmptyDashedBox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    width: "100%",
    height: "100%",
    overflow: "visible",
    style: {
      display: "block"
    },
    viewBox: "0 0 60.6478 61.8855",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 633201"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M33.0924 60.1684C33.8998 60.6345 34.8157 60.8799 35.748 60.8799C36.6802 60.8799 37.5961 60.6345 38.4035 60.1684L56.9922 49.5462C57.7988 49.0805 58.4688 48.4109 58.9349 47.6046C59.401 46.7982 59.6468 45.8835 59.6478 44.9521V23.7079C59.6468 22.7765 59.401 21.8618 58.9349 21.0554C58.4688 20.2491 57.7988 19.5795 56.9922 19.1138L27.5554 1.71155C26.748 1.2454 25.8321 1 24.8998 1C23.9675 1 23.0517 1.2454 22.2443 1.71155L3.65554 12.3337C2.84895 12.7994 2.17901 13.469 1.71291 14.2753C1.24681 15.0817 1.00096 15.9964 1 16.9278V38.1721C1.00096 39.1034 1.24681 40.0182 1.71291 40.8245C2.17901 41.6308 2.84895 42.3004 3.65554 42.7661L33.0924 60.1684Z",
    fill: "var(--fill-0, white)",
    stroke: "var(--stroke-0, #BFBFBF)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "4 4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M35.7479 60.8855V34.3302",
    stroke: "var(--stroke-0, #BFBFBF)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "4 4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M1.77003 15.6284L35.7479 34.3302L58.8776 21.0525",
    stroke: "var(--stroke-0, #BFBFBF)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "4 4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M12.9499 7.02315L47.6978 27.4792",
    stroke: "var(--stroke-0, #BFBFBF)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "4 4"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTbbEmptyDashedBox);
export default __webpack_public_path__ + "static/media/tbb-empty-dashed-box.66201123e705c705c209d482f933686e.svg";
export { ForwardRef as ReactComponent };